import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { responseStatus } from '../constants/responseStatus.const';
import { delay, finalize, Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { ToasterService } from '../../services/toaster.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DialogServiceWrapper } from '../../services/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class GetInterceptorService implements HttpInterceptor {
  private ngxLoader = inject(NgxUiLoaderService);
  private recentErrors = new Set<string>();
  private errorTimeout = 5000;
  constructor(
    private router: Router,
    private _toastrService: ToasterService,
    private dialogWrapper: DialogServiceWrapper
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.ngxLoader.start();
    return next.handle(req).pipe(
      delay(0),
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.handleResponse(event.body, req.method, req.url, req.headers);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      }),
      finalize(() => {
        this.ngxLoader.stop();
      })
    );
  }

  private handleResponse(body: any, method: string, requestUrl: string, headers: HttpHeaders): void {
    const excludeToaster = headers.get('X-Exclude-Toaster') === 'true';
    if (body?.status) {
      switch (body.status) {
        case responseStatus.SUCCESS:
          if (
            !excludeToaster &&
            (method === 'POST' ||
            method === 'PUT' ||
            method === 'DELETE' ||
            method === 'PATCH')
          ) {
            this._toastrService.showSuccess(body.message);
          }
          break;
        case responseStatus.BADREQUEST:
        case responseStatus.UNAUTHORIZED:
        case responseStatus.FORBIDDEN:
        case responseStatus.REQUESTTIMEOUT:
        case responseStatus.INTERNALSERVERERROR:
          this._toastrService.showError(body.message);
          if (
            body.statusCode === responseStatus.UNAUTHORIZED ||
            body.statusCode === responseStatus.FORBIDDEN
          ) {
            this.dialogWrapper.closeDialog();
          }
          break;
        default:
          break;
      }
    }
  }

  private handleError(error: HttpErrorResponse): void {
    const errorMessage = error?.error?.message;

    if (errorMessage === 'SomethingWentWrong') {
      return;
    }

    if (!this.recentErrors.has(errorMessage)) {
      this.recentErrors.add(errorMessage);
      this._toastrService.showError(errorMessage);
      setTimeout(
        () => this.recentErrors.delete(errorMessage),
        this.errorTimeout
      );
    }

    if (
      error.status === responseStatus.UNAUTHORIZED ||
      error.status === responseStatus.FORBIDDEN
    ) {
      this.dialogWrapper.closeDialog();
      this.router.navigate(['/auth/login']);
      localStorage.clear();
    }
  }
}
